// src/pages/misc/onboarding/OnboardingFrame.tsx
// Rising bar and Ventaje mark for the continuous onboarding. No profile menu.
import React, { useEffect } from 'react';
import './builder.css';

// [ANIMATION] [SPACING] The shell for the 4 screens after the builder (plan, extensiones, cuenta, checkout): same vignette, same left thread,
// same logo and "Paso X de Y" tag as StructureBuilderPage, but the middle is one scrolling column (.ob-flow-scroll) instead of the tree.
// `step` is 0-based; the tag shows step + 1. The thread fills to step / (total - 1) of the screen height (0% on the first step, 100% on the last).
// `band` sets the content width through data-band: wide 1040px (plan, extensions), mid 920px (sign-up), card 640px (checkout). See builder.css.
// `foot` (the Atrás / price / Continuar row) is rendered INSIDE the scroll area, after the content, not fixed to the window.
// The body is locked from scrolling while mounted (same as the builder), so only .ob-flow-scroll scrolls.
// [I18N] "Paso X de Y" and "Ventaje" are typed here.
const OnboardingFrame: React.FC<{
  step: number;
  total: number;
  /** wide = plan and extensions. mid = sign-up. card = checkout, same width as the structure card. */
  band?: 'wide' | 'mid' | 'card';
  children: React.ReactNode;
  foot?: React.ReactNode;
}> = ({ step, total, band = 'wide', children, foot }) => {
  const fill = total <= 1 ? 0 : (step / (total - 1)) * 100;

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <>
      <div className="ob-vignette" />
      <div className="ob-thread" aria-hidden>
        <div className="ob-thread-track" />
        <div className="ob-thread-fill" style={{ height: `${fill}%` }} />
      </div>
      <div className="ob ob-flow" data-band={band}>
        <div className="ob-top">
          <span className="ob-logo">Ventaje</span>
          <span className="ob-tag">Paso {step + 1} de {total}</span>
        </div>
        <div className="ob-flow-scroll ice-scroll">
          {children}
          {foot ? <div className="ob-flow-foot">{foot}</div> : null}
        </div>
      </div>
    </>
  );
};

export default OnboardingFrame;
